<template>
  <div class="container-fluid bg-light py-3">
    <main class="container-xl">
        <h1>Sait Básico</h1>
        <p class="fs-3">SAIT Básico es un punto de venta que se adapta al tamaño de tu empresa.</p>
        <p class="fs-5">Incluye factura electrónica, control de efectivo en caja, manejo de inventarios, cuentas por cobrar, enlace de sucursales, además cumple con todas las normas establecidas por el SAT</p>
        <div class="d-flex justify-content-center">
          <TablaComparacionSait />
        </div>
    </main>
  </div>
</template>

<script>
import TablaComparacionSait from './TablaComparacionSait.vue'

export default {
  components: { TablaComparacionSait },
  name: 'Sait-PDV',
}
</script>